import { PasswordChangeComponent } from '../password-change/password-change.component';
import { ChangeDetectionStrategy, Component, Inject } from '@angular/core';
import { PPL_DIALOG_DATA, PplDialogRef } from '@ppl/ui/dialog';
import { wrapAPICall } from '@ppl/utils/api.utils';
import { createDialogCloseResponse, createDialogSuccessResponse } from '@ppl/utils/dialog.utils';
import { BehaviorSubject } from 'rxjs';
import type { TFormGroup } from '@ppl/ui/form';
import type { DialogResponse } from '@ppl/utils/dialog.utils';
import type { Observable } from 'rxjs';
import type { PasswordChangeFormData } from '../password-change/password-change.component';

@Component({
    selector: 'ppl-password-change-dialog',
    templateUrl: './password-change-dialog.component.html',
    styleUrls: ['./password-change-dialog.component.scss'],
    changeDetection: ChangeDetectionStrategy.OnPush,
    standalone: false
})
export class PasswordChangeDialogComponent {

  loading$ = new BehaviorSubject<boolean>(false);

  form: TFormGroup<PasswordChangeFormData>;

  constructor(
    @Inject(PPL_DIALOG_DATA) private data: PasswordChangeDialogData,
    private dialogRef: PplDialogRef<PasswordChangeDialogComponent, DialogResponse<PasswordChangeDialogResponse>>,
  ) {
    this.form = PasswordChangeComponent.createChangePasswordForm();
  }

  onSave() {
    if (this.form.valid) {
      wrapAPICall(
        this.data.save(this.form.value),
        this.loading$
      ).subscribe(() => {
        this.dialogRef.close(createDialogSuccessResponse());
      });
    }
  }

  onCancel() {
    this.dialogRef.close(createDialogCloseResponse());
  }
}

export interface PasswordChangeDialogData {
  save: (formValues: PasswordChangeFormData) => Observable<any>;
}

export interface PasswordChangeDialogResponse {
}
